module.exports = __webpack_public_path__ + "2c159d0d05473040b53ec79df8797d32.woff";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/ionicons/fonts/ionicons.woff
// module id = 302
// module chunks = 1